export default __webpack_public_path__ + "static/media/cha_medic_lancet.5eebd54a.png";